import React from 'react';
import { getClientIdFromReturnUrl } from '@/lib/clientId';

type Props = {
  returnUrl?: string;
  include?: string[]; // e.g., ["mymb", "mymb-pkce"]
  exclude?: string[]; // e.g., ["mymb", "mymb-pkce"]
  children: React.ReactNode;
};

export const ClientGate: React.FC<Props> = ({ returnUrl, include, exclude, children }) => {
  const clientId = getClientIdFromReturnUrl(returnUrl) || '';
  if (include && include.length) return include.includes(clientId) ? <>{children}</> : null;
  if (exclude && exclude.length) return exclude.includes(clientId) ? null : <>{children}</>;
  return <>{children}</>;
};
